/**
 * The one place the /work-cafes/:city list rule lives.
 *
 * Deliberately standalone: it must NOT import the certification threshold.
 * Certification is being redesigned separately and must never silently change
 * what these pages show. A guard test asserts that separation.
 */

/** A café must reach this Grounded Score to be listed on a list page. */
export const CITY_PAGE_SCORE_THRESHOLD = 80;

/** Never show more than this many cafés, however many qualify. */
export const CITY_PAGE_MAX_CAFES = 10;

/**
 * Display floor. When fewer than this many reach the threshold, the next
 * highest scoring cafés in the same area fill the list up to this number.
 */
export const CITY_PAGE_LIST_MIN = 5;

/**
 * "list" runs the rule above. "hub" keeps the pre-rule behaviour: every scored
 * café the matching rule selects, no threshold, no cap, no fill.
 */
export type CityPageKind = "list" | "hub";

export function normalizeCityPageKind(value: unknown): CityPageKind {
  return value === "hub" ? "hub" : "list";
}
